import { objectOf } from "@altostra/type-validations";

export const isDeleteCdiSourcesConfigResult = objectOf({});
